module.exports = __webpack_public_path__ + "static/img/fuselage_663K.cdf428c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/fuselage_663K.jpg
// module id = VGaC
// module chunks = 0